import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/pages/Home';
import Shortcut from '@/pages/Home/Shortcut';
import Login from '@/pages/Login';
Vue.use(VueRouter);
export default new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            name: '首页',
            path: '/',
            component: Home,
            meta: {
                metaInfo: {
                    title: '耗邦邦-简单的聚合搜索引擎！',
                    keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            }
        },
        {
            name: '登录',
            path: '/login',
            component: Login,
            meta: {
                metaInfo: {
                    title: '耗邦邦-登陆注册',
                    keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            }
        },
        {
            path: '*',
            redirect: '/'
        }
    ]
});